<script setup lang="ts">
import type { ProjectRecord, SectionFeaturedProjectsListRecord } from '~/types/datocms'

const { locale } = useI18n()

const props = defineProps<{
  data: SectionFeaturedProjectsListRecord
}>()

const projects = ref<ProjectRecord[]>([])

const { data: projectsData } = await useProjects({
  variables: {
    locale: locale.value,
    first: props.data.recordsCount,
    allInLocation: props.data.location?.id
  }
})

if (projectsData) {
  projects.value = projectsData.allProjects as ProjectRecord[]
}

// Add CMS Overrides
if (Array.isArray(props.data.overrideProjects) && props.data.overrideProjects.length) {
  projects.value.unshift(...props.data.overrideProjects)
  projects.value = projects.value.slice(0, props.data.overrideProjects.length)
}
</script>

<template>
  <div v-if="data" class="bg-cream pb-4 pt-8 text-yellow lg:py-12">
    <div class="grid-default overflow-visible lg:container">
      <div
        v-if="data.title"
        class="col-span-full px-4 text-lg uppercase lg:col-span-3 lg:pr-0 lg:text-xl"
      >
        {{ data.title }}
      </div>
      <div class="col-span-full lg:col-span-9">
        <LazySwiperFeaturedProjects :data="projects" />
      </div>
    </div>
  </div>
</template>
